import '../styles/app.scss';
import './_images';
import {Ecards} from './components/Ecards';

document.addEventListener(
	'DOMContentLoaded',
	() => {
		console.log('App ready');
        new Ecards()
	},
	false
);
